<!--  -->
<template>
  <div class="content">
    <div class="ban">
      <img @click="jump" src="../../assets/img/shop/banner.png" alt="" />
    </div>
    <!-- 功能特点 -->
    <div class="characteristic">
      <div class="img">
        <img src="../../assets//img/shop/bg.png" alt="" />
      </div>
      <div class="card flex">
        <div class="left">
          <div class="all_text">
            <img src="../../assets/img/index/ico.png" alt="" />
            <div class="text">
              跨境电商辅助系统 <br />
              功能特点
            </div>
            <div class="row"></div>
          </div>
            <div class="info_text">
              导入电商平台订单数据，<br>
               导出全国跨境电商统一版订单数据，
              是跨境电商企业必须的数据转换工具。
            </div>
        </div>
        <div class="right">
          <div class="list_ico">
            <div
              class="li"
              v-for="(item, index) in js_list"
              :key="index"
              :style="index == 0 || index == 2 ? 'margin-top:50px' : ''"
            >
              <div class="li_left">
                <img :src="item.img" alt="" />
              </div>
              <div class="li_right">
                <div class="title">
                  {{ item.title }}
                </div>
                <div class="text">
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 系统主要五个模块 -->
    <div class="sys card">
      <Link text="系统主要五个模块" />
      <div class="sys_list">
        <div class="li" v-for="(item, index) in sys_list" :key="index">
          <div class="title">
            {{ item.title }}
          </div>
          <img :src="item.img" alt="" />
          <div class="text">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
      js_list: [
        {
          title: "特点一",
          text: "系统严格按照相关业务流程进行设计。",
          img: require("../../assets/img/shop/1.png"),
        },
        {
          title: "特点二",
          text: "实现一键导入、导出、数据生成等功能。",
          img: require("../../assets/img/shop/2.png"),
        },
        {
          title: "特点三",
          text: "具有集约化 、规范化、智能核对等优势。",
          img: require("../../assets/img/shop/3.png"),
        },
        {
          title: "特点四",
          text: "帮助企业用户改善工作方式。",
          img: require("../../assets/img/shop/4.png"),
        },
      ],
      sys_list: [
        {
          title: "01",
          text: "备案数据",
          img: require("../../assets/img/shop/ico1.png"),
        },
        {
          title: "02",
          text: "客户信息",
          img: require("../../assets/img/shop/ico2.png"),
        },
        {
          title: "03",
          text: "原始单据",
          img: require("../../assets/img/shop/ico3.png"),
        },
        {
          title: "04",
          text: "总署数据",
          img: require("../../assets/img/shop/ico4.png"),
        },
        {
          title: "05",
          text: "用户管理",
          img: require("../../assets/img/shop/ico5.png"),
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 底部
    jump(index) {
      let jump = document.getElementById("d_jump");
      // 获取需要滚动的距离
      let total = jump.offsetTop;
      console.log(jump.offsetTop);

      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang='less'>
@import url(../shop/pc);
</style>